import React from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames/bind';
import styles from './styles.scss';

const cx = classNames.bind(styles);

export default function Backdrop({ visible, onClick }) {
  return createPortal(
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className={cx('backdrop', { visible })} onClick={onClick} />,
    document.getElementsByTagName('body')[0]
  );
}
